export var COMPILER_DEFAULT_OPT = 16 /* COMPILER_OPT_FLAGS.ALLOW_CUSTOM_OPTIMISER */ |
    2 /* COMPILER_OPT_FLAGS.USE_NEW_FUCTION */ |
    1 /* COMPILER_OPT_FLAGS.USE_ES_PARAMS */ |
    4 /* COMPILER_OPT_FLAGS.SKIP_NULL_COERCE */ |
    8 /* COMPILER_OPT_FLAGS.SKIP_DOMAIN_MEM */;
//| COMPILER_OPT_FLAGS.DEBUG_UNDERRUN;
